 import {motion} from 'framer-motion'

export const WhatAreNativeApps = () => {
  return (
    <section className='container'>

    <div className=" space-y-10 bg-[#f3ebfa] px-5 md:px-10 lg:px-20 py-10 rounded-3xl">
      <motion.h2
        initial={{ opacity: 0, y: 40 }} 
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
        className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  font-bold text-dark font-butler"
        >
        What Are Native Apps?{" "}
      </motion.h2>
      <div className='space-y-4'>
        <p className="text-base leading-[1.625rem]">
          Native apps are mobile applications built specifically for a single
          operating system, such as iOS or Android, using that platform’s
          official programming languages, SDKs, and development tools. In
          software programming, “native” means the code is compiled to run
          directly on a particular platform’s runtime environment rather than
          through a cross-platform abstraction layer. Native app development
          therefore involves creating and maintaining separate codebases for
          each platform (Swift or Objective-C for iOS, Kotlin or Java for
          Android) to ensure robust integration with system APIs, device
          hardware, security layers, and platform-specific UI components.
        </p>
        <p className="text-base leading-[1.625rem]">
          An application is considered truly native when its interface,
          performance, and behavior are aligned with the operating system’s
          design guidelines and it runs without relying on web views or shared
          cross-platform frameworks for its core functionality. You can identify
          native apps by their platform-authentic feel: highly optimized
          performance, fluid animations, and full access to device-specific
          features.
        </p>
        <p className="text-base leading-[1.625rem]">
          Leading mobile applications such as WhatsApp, YouTube, Netflix,
          Amazon, Uber, Gmail and Spotify, are built as native apps to ensure a
          premium user experience.
        </p>
      </div>
    </div>
          </section>
  );
};
